<template>
    <div style="background-color: #f2f2f2;height: 100%;">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            操作日志
        </div>
        <div style="padding: 20px;">

            <div style="height: 10px;"></div>

            <div>
                <template>

                    <el-table :data="tableData" :height="th" border style="width: 100%;">
                        <el-table-column prop="remarks" label="操作信息"></el-table-column>
                        <el-table-column prop="createTime" label="创建时间" width="200">
                            <template slot-scope="scope">
                                <p>{{scope.row.createTime | timefilters }}</p>
                            </template>
                        </el-table-column>
                    </el-table>

                    <div style="text-align: left;background-color: #fff;padding: 10px;">
                        <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                        <div style="float: left;">
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="totalItems"
                                    :page-size="pageSize"
                                    :current-page.sync="currentPage"  @current-change="current_change">
                            </el-pagination>
                        </div>
                        <div style="clear: both;"></div>
                    </div>


                </template>
            </div>

        </div>

        <!-- <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add> -->
        <!-- <Edit ref="myEdit" v-show="showModalEdit" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit> -->
        <!-- <EditSon ref="myEditSon" v-show="showModalEditSon" v-on:closeEditSon="closeEditSon" v-on:getList="getList"></EditSon> -->

    </div>
</template>

<script>

    import {getStaffCode} from "@/utils/auth";
    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    // import Edit from "./Edit";
    // import Add from "./Add";
    // import EditSon from "./EditSon";

    export default {
        name: "Page",
        // components:{Add,Edit,EditSon},

        //注册局部过滤器
        filters: {
            timefilters(val) {
                if (val == null || val == "") {
                    return "";
                } else {
                    let d = new Date(val);   //val 为表格内取到的后台时间
                    let month =
                        d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
                    let day = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
                    let hours = d.getHours() < 10 ? "0" + d.getHours() : d.getHours();
                    let min = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();
                    let sec = d.getSeconds() < 10 ? "0" + d.getSeconds() : d.getSeconds();
                    let times=d.getFullYear() + '-' + month + '-' + day + ' ' + hours + ':' + min + ':' + sec;
                    return times;
                }
            }
        },

        data(){
            return{
                loading:false,

                showModalAdd:false,
                showModalEdit:false,
                showModalEditSon:false,

                tableData:null,
                totalItems: 0,
                pageSize:20,
                currentPage:1,

                th:0,

            }
        },

        created(){
            this.getList();
            this.th = this.$store.state.tableHeight+40;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                console.log(val);
                this.th = val;
            },
        },
        methods:{


            toggleModalAdd:function(){
                this.$refs.myAdd.init();
                this.showModalAdd = !this.showModalAdd;
            },
            closeAdd:function(){
                this.showModalAdd = !this.showModalAdd;
            },


            handleEdit(index, row) {
                this.$refs.myEdit.init(row);
                this.showModalEdit = !this.showModalEdit;
            },
            closeEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },


            handleEditSon(index,row){
                this.$refs.myEditSon.init(row);
                this.showModalEditSon = !this.showModalEditSon;
            },
            closeEditSon:function(){
                this.showModalEditSon = !this.showModalEditSon;
            },


            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },

            getList(isSearch){
                if(isSearch)this.currentPage=1
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Log/Page",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                    }
                }).then( (response)=> {
                    console.log(response);
                    if(response.data.error == 0){
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },



        }
    }
</script>

